// src/pages/Dashboard/DashboardEmbedV2.tsx
import React from "react";

const DashboardEmbedV2: React.FC = () => {
  return (
    <div
      style={{
        height: "calc(100vh - 64px - 24px)",
        width: "100%",
        margin: "-12px -24px -6px -24px",
        overflow: "hidden",
        background: "linear-gradient(135deg, #f5f7fa 0%, #e8ecf1 100%)",
      }}
    >
      {/* Power BI Public Embed - No authentication required */}
      <iframe
        title="DataTool_Dashboard_V2"
        width="100%"
        height="100%"
        src="https://app.powerbi.com/view?r=eyJrIjoiNDI5Mzg0YzEtMTk2Yy00NjUyLTg1OTUtMzJjMmYwYzQ1ZjBlIiwidCI6IjNlMzdlZDZlLTg2ZDYtNGM5OC1hOGYxLTI2YWI1ZWM1NWQwMiIsImMiOjN9"
        style={{ border: "none", display: "block" }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DashboardEmbedV2;
